
class CustomBundleProduct extends HTMLElement {
  constructor() {
    super();
    this._inited = false;
    this._selectionCounter = 0;
    this.onSizePackChange = this.onSizePackChange.bind(this);
    this.onPlusMinusClick = this.onPlusMinusClick.bind(this);
    this.onMediaClick = this.onMediaClick.bind(this);
    this.onPopupClose = this.onPopupClose.bind(this);
    this.repaintQueued = false;
    this._mobileStickyRaf = null;
    this._mobileStickyScrollHandler = null;
    this._mobileStickyResizeHandler = null;
    
  }   

  connectedCallback() {
    const observer = new IntersectionObserver((entries, obs) => {
      if (!entries[0]?.isIntersecting) return;
      obs.unobserve(entries[0].target);
      if (!this._inited) this.init();
    }, { rootMargin: "0px 0px 300px 0px" });
    observer.observe(this);
  }                      

  init() {
    var this2 = this;
    this.$doc = $(document);
    this.$root = $(this);
    this.initMobileStickyProgress();
    this.initProductSwiper();
    this.$selectedWrapperAll = $('.selected-packs-wrapper');
    this.$selectedContainerAll = $('.selected-packs');
    //this.restorePackSize();
    this.updateWrapperAndContainer();
    
    this.$doc
      .off('change.sizepack', 'input[name="size-pack"]')
      .on('change.sizepack', 'input[name="size-pack"]', this.onSizePackChange)
      .off('click.plusminus', '.custom-product-selector-plus, .custom-product-selector-minus')
      .on('click.plusminus', '.custom-product-selector-plus, .custom-product-selector-minus', this.onPlusMinusClick)
      .off('click.mediapopup', '.custom-product-selector-item .custom-selector-product-media')
      .on('click.mediapopup', '.custom-product-selector-item .custom-selector-product-media', this.onMediaClick)
      .off('click.popupclose', '.popup-description-wrapper .popup-cross-button, .popup-information-overlay')
      .on('click.popupclose', '.popup-description-wrapper .popup-cross-button, .popup-information-overlay', this.onPopupClose)
      .off('click.frequency', '.bundle-frequency-option')
      .on('click.frequency', '.bundle-frequency-option', function(e){
        e.preventDefault();
        const planId = String($(this).attr('data-plan-id') || '');
        if (!planId) return;
        $('.selling_plan_select_container').val(planId).trigger('change');
        $('.bundle-frequency-option').removeClass('is-active');
        $(this).addClass('is-active');
        this2.setPrices();
      });
     
     $('.custom-product-selector-input').val(0).attr('min', 0);
    //this.restoreSelPack();
     this.setPrices();
      $('input[name="product-subscription"]').change(function(){
        this2.setPrices();
      });

      $('.selling_plan_select_container').off('change.bundleplan').on('change.bundleplan', function(){
        this2.updateFrequencyButtons();
        this2.setPrices();
      })
       $('.custom-atc-btn-checkout').find('span').show();
      $('.custom-atc-btn-checkout').find('.loading__spinner').addClass('hidden');
     $('.custom-atc-btn-checkout').click(async function() {
        try {
          var this3 = this;
       $(this).find('span').hide();
        $(this).find('.loading__spinner').removeClass('hidden');
        const bundleProductData = {
          productId: $('input[name="size-pack"]:checked').attr('data-productid'),
          variantId: $('input[name="size-pack"]:checked').attr('data-variant'), 
          handle: $('input[name="size-pack"]:checked').attr('data-handle'),
        };
        if($('input[name="product-subscription"]:checked').val() == 'susbscribe-and-save'){
          bundleProductData['sellingPlan'] = $('.selling_plan_select_container').val();
        }

        const bundle = {
          externalVariantId: bundleProductData.variantId,
          externalProductId: bundleProductData.productId, 
        };
           
        var selections = [];
        var selectionstr = '';  
        $('.custom-product-selector-input').each(function(){
            if($(this).val() > 0){
              var rawData = $(this).parents('.custom-product-selector-item').find('.variants-data').html();
              var doc = new DOMParser().parseFromString(rawData, "text/html");
              rawData = doc.body.textContent || doc.body.innerText;  // Extract plain text after decoding
              var product = JSON.parse(rawData);
              const label = $('.selling_plan_select_container').find('option:selected').attr('data-name');
              const varid = $(this).attr('data-varid-pack');
              const sellingPlanId = this2.getSellingPlanIdForLabel(product, varid, label);
              const selitem = {
                collectionId: '509349921070',
                externalProductId: $(this).attr('data-productid'),
                externalVariantId: varid,
                quantity: Number($(this).val()),  
              }
              if($('input[name="product-subscription"]:checked').val() == 'susbscribe-and-save'){
                selitem['sellingPlan'] = sellingPlanId;
              }
              selectionstr =selectionstr + '\n' + $(this).val() + 'x '+$(this).parents('.custom-product-selector-item').find('.custom-selector-product-title').html();  
              selections.push(selitem);
            }
        })
        bundle['selections'] = selections;
         // alert('working' + JSON.stringify(selections))
        
        const rbId = await recharge.bundle.getBundleId(bundle);
        const isValid = await recharge.bundle.validateBundleSelection(bundle);
        const cartItems = await recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
        const cartData = { items: cartItems };
         console.log(bundle) 
         console.log(cartData) 
        console.log(rbId)
      
        console.log(isValid)  
         
        
        if(isValid.valid === true){

           var properties = {
            'Contents':  selectionstr.substring(1),
            "_rb_id": rbId
           }  

           var sellplan = '';

           if($('input[name="product-subscription"]:checked').val() == 'susbscribe-and-save'){
              sellplan = $('.selling_plan_select_container').val();
           }

           $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              contentType: 'application/json; charset=utf-8',
              data: JSON.stringify({
                items: [
                  { 
                    id: $('input[name="size-pack"]:checked').attr('data-variant'), 
                    quantity: 1, 
                    selling_plan: sellplan,
                    properties: properties
                  }
                ]
              }),
              success: function(data){  
                 $('.custom-atc-btn-checkout').find('span').show();
                  $('.custom-atc-btn-checkout').find('.loading__spinner').addClass('hidden');
                  window.location.href = '/cart';
              },
              error: function(xhr){
                 $('.custom-atc-btn-checkout').find('span').show();
                 $('.custom-atc-btn-checkout').find('.loading__spinner').addClass('hidden');
                let msg = 'Add to cart failed';
                try {
                  const res = JSON.parse(xhr.responseText);
                  msg = res.description || res.message || msg;
                  alert(msg);
                } catch(e){}
                onError({ status: xhr.status, message: msg, raw: xhr });
              }
            });
             
         
        }
        }
        catch(err) {
         alert(err.message);
        }
        
      });


    this._inited = true;
    const $checked = $('input[name="size-pack"]:checked');
    if ($checked.length) {
      this.onSizePackChange({ currentTarget: $checked[0] });
    }
  } 


  getPackFallbackSavingPercent(packSize) {
    packSize = Number(packSize || 0);

    if (packSize === 6) return 7;
    if (packSize === 12) return 15;
    if (packSize === 24) return 21;

    return 0;
  }

  getPackProgressPercent(packSize) {
    packSize = Number(packSize || 0);

    if (packSize === 6) return 33.33;
    if (packSize === 12) return 66.66;
    if (packSize === 24) return 100;

    return 0;
  }

  getPackSavingMessage(packSize, savingPercent) {
    packSize = Number(packSize || 0);
    savingPercent = Number(savingPercent || 0);

    if (packSize === 6) {
      return '6 pack selected · upgrade to 12-pack to save 15%';
    }

    if (packSize === 12) {
      return '12 pack selected · upgrade to 24-pack to save 21%';
    }

    if (packSize === 24) {
      return "You're saving the max on the 24-pack";
    }

    return savingPercent > 0 ? 'Save ' + savingPercent + '%' : '';
  }

  setPrices(){
    const $variantJson = $('.subscription-packs-container').find('.variant-json');
    if (!$variantJson.length) return;

    let productmain = [];
    try {
      productmain = JSON.parse($variantJson.html());
    } catch(e) {
      console.log('Bundle variant JSON parse error', e);
      return;
    }

    const selectedVariantId = String($('input[name="size-pack"]:checked').attr('data-variant') || '');
    const selectedPackSize = Number($('input[name="size-pack"]:checked').val() || 0);
    const isSubscription = $('input[name="product-subscription"]:checked').val() === 'susbscribe-and-save';
    const selectedPlanId = String($('.selling_plan_select_container').val() || '');

    const selectedVariant = productmain.find((variant) => String(variant.id) === selectedVariantId) || productmain[0];
    if (!selectedVariant) return;

    let selectedAllocation = null;

    if (selectedVariant.selling_plan_allocations && selectedVariant.selling_plan_allocations.length) {
      selectedAllocation = selectedVariant.selling_plan_allocations.find((allocation) => {
        return String(allocation.selling_plan_id) === selectedPlanId;
      }) || selectedVariant.selling_plan_allocations[0];
    }

    const oneTimePrice = Number(selectedVariant.price || 0);
    const oneTimeCompare = Number(selectedVariant.compare_at_price || 0);
    const subPrice = selectedAllocation ? Number(selectedAllocation.price || oneTimePrice) : oneTimePrice;
    const subCompare = selectedAllocation ? Number(selectedAllocation.compare_at_price || oneTimePrice) : oneTimePrice;
 
    const oneTimeDisplayCompare = oneTimeCompare > oneTimePrice ? oneTimeCompare : 0;
    const subDisplayCompare = subCompare > subPrice ? subCompare : 0;

    const activePrice = isSubscription ? subPrice : oneTimePrice;
    const activeCompare = isSubscription ? (subDisplayCompare || subPrice) : (oneTimeDisplayCompare || oneTimePrice);

    $('.one-time-purchase-price').html(Shopify.formatMoney(oneTimePrice));
    $('.bundle-onetime-price').html(Shopify.formatMoney(oneTimePrice));

    $('.susbscribe-save-price').html(Shopify.formatMoney(subPrice));
    $('.bundle-subscribe-price').html(Shopify.formatMoney(subPrice));
    $('.susbscribe-save-cprice').html(subDisplayCompare ? Shopify.formatMoney(subDisplayCompare) : '');
    $('.bundle-subscribe-compare').html(subDisplayCompare ? Shopify.formatMoney(subDisplayCompare) : '');

    $('.bundle-summary-pack-label').text((selectedPackSize || '') + '-pack');
    $('.bundle-summary-mode-label').text(isSubscription ? 'subscription' : 'one-time');

    if (activeCompare > activePrice) {
      $('.bundle-summary-original-price').html(Shopify.formatMoney(activeCompare)).show();
    } else {
      $('.bundle-summary-original-price').html('').hide();
    }

    $('.bundle-summary-current-price, .bundle-total-price, .bundle-atc-price').html(Shopify.formatMoney(activePrice));

    const discountAmount = Math.max(0, activeCompare - activePrice);
    $('.bundle-summary-discount').html('-' + Shopify.formatMoney(discountAmount));

    if (selectedPackSize > 0) {
      $('.bundle-summary-per-bottle').html(Shopify.formatMoney(activePrice / selectedPackSize) + ' / bottle');
      $('.bundle-subscribe-per-bottle').html(Shopify.formatMoney(subPrice / selectedPackSize) + ' / bottle');
      $('.bundle-onetime-per-bottle').html(Shopify.formatMoney(oneTimePrice / selectedPackSize) + ' / bottle');
    }

    if (isSubscription) {
      $('.perbottle-onetime').hide();
      $('.perbottle-subscription').show();
      $('.bundle-subscription-panel').show();
      $('.bundle-summary-mode').text('subscription');
    } else {
      $('.perbottle-onetime').show();
      $('.perbottle-subscription').hide();
      $('.bundle-subscription-panel').hide();
      $('.bundle-summary-mode').text('one-time');
    }

    const bundleInstance = this;
 
    $('.custom-product-select-pack').each(function(index){
      const $pack = $(this);
      const $input = $pack.find('input[name="size-pack"]');
      const packSize = Number($input.val() || 0);
      const packVariantId = String($input.attr('data-variant') || '');
      const variant = productmain.find((item) => String(item.id) === packVariantId);

      if (!variant || !packSize) return;

      const allocation = variant.selling_plan_allocations && variant.selling_plan_allocations.length ? variant.selling_plan_allocations[0] : null;
      const packOnePrice = Number(variant.price || 0);
      const packSubPrice = allocation ? Number(allocation.price || packOnePrice) : packOnePrice;
      const packSubCompare = allocation ? Number(allocation.compare_at_price || packOnePrice) : packOnePrice;
      const packOneCompare = Number(variant.compare_at_price || 0) || packOnePrice;
      const packActivePrice = isSubscription ? packSubPrice : packOnePrice;
      const packActiveCompare = isSubscription ? packSubCompare : packOneCompare;
      const packSavings = Math.max(0, packActiveCompare - packActivePrice);
      let packSavingsPercent = packActiveCompare > 0 ? Math.round((packSavings * 100) / packActiveCompare) : 0;

      if (!packSavingsPercent) {
        packSavingsPercent = bundleInstance.getPackFallbackSavingPercent(packSize);
      }

      $pack.find('.bundle-pack-price').html(Shopify.formatMoney(packActivePrice));
      $pack.find('.bundle-pack-compare').html(packActiveCompare > packActivePrice ? Shopify.formatMoney(packActiveCompare) : '');
      $pack.find('.perbottle-subscription').html(Shopify.formatMoney(packSubPrice / packSize) + ' / bottle (sub)');
      $pack.find('.perbottle-onetime').html(Shopify.formatMoney(packOnePrice / packSize) + ' / bottle');

      if (packSavingsPercent > 0) {
        $pack.find('.bundle-pack-save').text('Save ' + packSavingsPercent + '%').show();
      } else {
        $pack.find('.bundle-pack-save').text('').hide();
      }
    });

    this.updateFrequencyButtons();
    this.updateBundleUi();
  }

  getSelectedPackLabel(){
    return $('input[name="size-pack"]:checked').closest('.custom-product-select-pack').find('.bundle-pack-title').text().trim() || (($('input[name="size-pack"]:checked').val() || '') + ' pack');
  }

  updateFrequencyButtons(){
    const selectedPlan = String($('.selling_plan_select_container').val() || '');
    const selectedVariantId = String($('input[name="size-pack"]:checked').attr('data-variant') || '');

    $('.bundle-frequency-option').removeClass('is-active').each(function(){
      const $btn = $(this);
      const optionVariantId = String($btn.attr('data-varid') || '');
      const isVisible = !optionVariantId || optionVariantId === selectedVariantId;

      $btn.toggle(isVisible);

      if (isVisible) {
        $btn.toggleClass('is-active', String($btn.attr('data-plan-id')) === selectedPlan);
      }
    });
  }

  updateBundleUi(){
    const capacity = this.getCapacity();
    const total = this.getTotalSelected();
    const remaining = Math.max(0, capacity - total);

    const packSavingPercent = this.getPackFallbackSavingPercent(capacity);
    const packProgressPercent = this.getPackProgressPercent(capacity);
    const packMessage = this.getPackSavingMessage(capacity, packSavingPercent);

    $('.bundle-selected-count').text(total);
    $('.bundle-capacity-count').text(capacity);

    $('.bundle-progress-fill').css('width', packProgressPercent + '%');
    $('.bundle-savings-message').text(packMessage);
    $('.bundle-savings-percent').text(packSavingPercent > 0 ? 'Save ' + packSavingPercent + '%' : '');

    if (remaining > 0) {
      $('.bundle-atc-message').text('Choose ' + remaining + ' more');
    } else {
      const isSub = $('input[name="product-subscription"]:checked').val() === 'susbscribe-and-save';
      $('.bundle-atc-message').text(isSub ? 'Subscribe & save' : 'Add to cart');
    }

    $('.bundle-summary-pack-label').text(capacity + '-pack');

    $('.custom-atc-btn-checkout').toggleClass('disabled', capacity === 0 || total !== capacity);
    this.updateMobileStickyProgress();
    this.updatePlusMinusStates();
  }

    /* =========================================================
     Product slider
  ========================================================= */

  initProductSwiper() {
     var swiper = new Swiper(".custom-bundle-mobile-media", {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }


  /* =========================================================
     Mobile sticky bundle progress
     Dynamic for 6-pack, 12-pack and 24-pack
  ========================================================= */

  initMobileStickyProgress() {
    this.$mobileStickyProgress = this.$root.find('[data-mobile-bundle-progress]').first();
    this.$mobileSavingsCard = this.$root.find('.bundle-savings-card').first();

    if (!this.$mobileStickyProgress.length || !this.$mobileSavingsCard.length) {
      return;
    }

    this._mobileStickyScrollHandler = () => {
      if (this._mobileStickyRaf) return;

      this._mobileStickyRaf = requestAnimationFrame(() => {
        this._mobileStickyRaf = null;
        this.syncMobileStickyVisibility();
      });
    };

    this._mobileStickyResizeHandler = () => {
      this.syncMobileStickyVisibility();
      this.updateMobileStickyProgress();
    };

    window.addEventListener('scroll', this._mobileStickyScrollHandler, {
      passive: true
    });

    window.addEventListener('resize', this._mobileStickyResizeHandler);

    requestAnimationFrame(() => {
      this.syncMobileStickyVisibility();
      this.updateMobileStickyProgress();
    });
  }

  syncMobileStickyVisibility() {
    if (!this.$mobileStickyProgress || !this.$mobileStickyProgress.length) {
      return;
    }

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (!isMobile) {
      this.$mobileStickyProgress
        .removeClass('is-visible')
        .attr('aria-hidden', 'true');

      return;
    }

    if (!this.$mobileSavingsCard || !this.$mobileSavingsCard.length) {
      return;
    }

    const cardRect = this.$mobileSavingsCard[0].getBoundingClientRect();

    const rawHeaderHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height');

    const headerHeight = parseFloat(rawHeaderHeight) || 0;
    const shouldShow = cardRect.bottom <= headerHeight;

    this.$mobileStickyProgress
      .toggleClass('is-visible', shouldShow)
      .attr('aria-hidden', shouldShow ? 'false' : 'true');
  }

  updateMobileStickyProgress() {
    if (!this.$mobileStickyProgress || !this.$mobileStickyProgress.length) {
      return;
    }

    const capacity = Number(this.getCapacity() || 0);
    const totalSelected = Number(this.getTotalSelected() || 0);

    if (!capacity) {
      return;
    }

    const visibleSelected = Math.min(totalSelected, capacity);
    const remaining = Math.max(0, capacity - visibleSelected);
    const isComplete = remaining === 0;

    this.$mobileStickyProgress
      .attr('data-pack-size', String(capacity))
      .attr('data-selected-count', String(visibleSelected));

    this.$mobileStickyProgress
      .find('.mobile-bundle-sticky-selected-count')
      .text(visibleSelected);

    this.$mobileStickyProgress
      .find('.mobile-bundle-sticky-capacity-count')
      .text(capacity);

    this.$mobileStickyProgress
      .find('.mobile-bundle-sticky-pack-label')
      .text(capacity + '-pack');

    const $status = this.$mobileStickyProgress.find('.mobile-bundle-sticky-status');

    if (isComplete) {
      $status
        .addClass('is-success')
        .text('Success!');
    } else {
      $status
        .removeClass('is-success')
        .html(
          'Add <span class="mobile-bundle-sticky-remaining-count">' +
          remaining +
          '</span> More'
        );
    }

    this.$mobileStickyProgress
      .find('.mobile-bundle-sticky-bottle')
      .each(function(index) {
        $(this).toggleClass('is-filled', index < visibleSelected);
      });
  }

  disconnectedCallback() {
    if (this._mobileStickyScrollHandler) {
      window.removeEventListener('scroll', this._mobileStickyScrollHandler);
    }

    if (this._mobileStickyResizeHandler) {
      window.removeEventListener('resize', this._mobileStickyResizeHandler);
    }

    if (this._mobileStickyRaf) {
      cancelAnimationFrame(this._mobileStickyRaf);
      this._mobileStickyRaf = null;
    }
  }

  getSellingPlanIdForLabel(product, variantId, label) { 
    const normalized = label
      .replace(/every\s+other\s+week/i, 'Bi-Weekly Delivery')
      .trim()
      .toLowerCase();
 
    const group = product.selling_plan_groups.find(g =>
      g.name.trim().toLowerCase() === normalized
    );

    if (!group) return null; 

    const variant = product.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return null;
 
    for (const plan of group.selling_plans) {
      const ok = (variant.selling_plan_allocations || []).some(a =>
        String(a.selling_plan_id) === String(plan.id)
      );
      if (ok) return plan.id;  
    }

    return null;
  }

  get packSize() {
    const $checked = $('input[name="size-pack"]:checked');
    const v = $checked.val() || localStorage.getItem('packsize');
    return parseInt(v, 10) || 0;
  }

  set packSize(val) {
    const v = parseInt(val, 10) || 0;
    try { localStorage.setItem('packsize', String(v)); } catch (e) {}
  }

  saveSelPack() {
    const data = [];
    $('.custom-product-selector-item').each(function () {
      const $qty = $(this).find('.custom-product-selector-input');
      const q = parseInt($qty.val(), 10) || 0;
      const id = $qty.attr('data-varid-pack');
      if (id && q > 0) data.push({ id: String(id), qty: q });
    });
    try { localStorage.setItem('selpack', JSON.stringify(data)); } catch (e) {}
  }

  restoreSelPack() {
    let arr = [];
    try {
      arr = JSON.parse(localStorage.getItem('selpack') || '[]') || [];
    } catch (e) { arr = []; }
    arr.forEach((it) => {
      const $q = $('.custom-product-selector-input[data-varid-pack="' + it.id + '"]');
      if ($q.length) {
        const val = parseInt(it.qty, 10) || 0;
        $q.val(val);
        const $item = $q.closest('.custom-product-selector-item');
        $item.find('input[type="checkbox"]').prop('checked', val > 0);
        if (val > 0 && $item.data('sequence') == null) {
          this._selectionCounter += 1;
          $item.data('sequence', this._selectionCounter);
        }
      }
    });
    this.queueRepaint();
    this.saveSelPack();
    this.syncMinusFromSelpack();
    this.updatePlusMinusStates();
    this.updateBundleUi();
  }

  restorePackSize() {
    const saved = localStorage.getItem('packsize');
    if (saved) {
      const $saved = $('input[name="size-pack"][value="' + saved + '"]');
      if ($saved.length) $saved.prop('checked', true);
    } else {
      const $default = $('input[name="size-pack"]:checked');
      if ($default.length) this.packSize = $default.val();
    }
  }

  getCapacity() {
    return this.packSize;
  }

  getTotalSelected() {
    let t = 0;
    $('.custom-product-selector-input').each(function () {
      t += parseInt($(this).val(), 10) || 0;
    });
    return t;
  }

  itemsSortedBySequenceAsc() {
    const $items = $('.custom-product-selector-item').filter(function () {
      return (parseInt($(this).find('.custom-product-selector-input').val(), 10) || 0) > 0;
    });
    return $items.sort((a, b) => {
      const sa = $(a).data('sequence') || 0;
      const sb = $(b).data('sequence') || 0;
      return sa - sb;
    });
  }

  setSequenceIfNeeded($item) {
    if ($item.data('sequence') == null) {
      this._selectionCounter += 1;
      $item.data('sequence', this._selectionCounter);
    }
  }

  clearSequence($item) {
    $item.removeData('sequence');
  }

  syncMinusFromSelpack() {
    let map = {};
    try {
      (JSON.parse(localStorage.getItem('selpack') || '[]') || []).forEach(function (it) {
        map[String(it.id)] = parseInt(it.qty, 10) || 0;
      });
    } catch (e) {}
    $('.custom-product-selector-item').each(function () {
      const $item = $(this);
      const $qty  = $item.find('.custom-product-selector-input');
      const id    = String($qty.attr('data-varid-pack') || '');
      const q     = map[id] || 0;
      $item.find('.custom-product-selector-minus').toggleClass('disabled', q <= 0);
      $item.find('input[type="checkbox"]').prop('checked', q > 0);
    });
  }

  updatePlusMinusStates() {
    const cap = this.getCapacity();
    const total = this.getTotalSelected();
    $('.custom-product-selector-item').each(function () {
      const $item  = $(this);
      const $qty   = $item.find('.custom-product-selector-input');
      const val    = parseInt($qty.val(), 10) || 0;
      const $minus = $item.find('.custom-product-selector-minus');
      const $plus  = $item.find('.custom-product-selector-plus');
      const totalOthers = total - val;
      const allowedForThis = Math.max(0, cap - totalOthers);
      $minus.toggleClass('disabled', val <= 0);
      $plus.toggleClass('disabled', val >= allowedForThis);
    });
  }

  trimToCapacity() {
    const cap = this.getCapacity();
    let total = this.getTotalSelected();
    if (total <= cap) return;
    const $selected = $('.custom-product-selector-item').filter(function () {
      return (parseInt($(this).find('.custom-product-selector-input').val(), 10) || 0) > 0;
    }).sort((a, b) => {
      const sa = $(a).data('sequence') || 0;
      const sb = $(b).data('sequence') || 0;
      return sb - sa;
    });
    $selected.each((_, el) => {
      if (total <= cap) return false;
      const $item = $(el);
      const $qty = $item.find('.custom-product-selector-input');
      let val = parseInt($qty.val(), 10) || 0;
      const remove = Math.min(val, total - cap);
      val -= remove;
      $qty.val(val);
      if (val <= 0) this.clearSequence($item);
      total -= remove;
    });
  }  

  allocateBoxes() {
    const capacity = this.getCapacity();
    const picks = [];
    this.itemsSortedBySequenceAsc().each(function () {
      const $item = $(this);
      const $qty = $item.find('.custom-product-selector-input');
      const qty = parseInt($qty.val(), 10) || 0;
      const variantId = $qty.attr('data-varid-pack');
      const imageUrl = $qty.attr('data-pimg');
      for (let i = 0; i < qty && picks.length < capacity; i++) {
        picks.push({ variantId, imageUrl });
      }
      if (picks.length >= capacity) return false;
    });
    const $wrapper = $('.selected-packs-wrapper:visible');
    const $boxes = $wrapper.find('.selected-item-box');
    const placeholder = 'https://cdn.shopify.com/s/files/1/0809/2516/3822/files/ChatGPT_Image_Sep_17_2025_02_57_50_PM_copynew.png?v=1758102626';
    $boxes.each(function (i) {
      if (i < picks.length) {
        const { variantId, imageUrl } = picks[i];
        $(this)
          .data('variant_id', variantId)
          .attr('data-variant_id', variantId)
          .addClass('filled')
          .find('img').attr('src', imageUrl);
      } else {
        $(this)
          .removeData('variant_id')
          .removeAttr('data-variant_id')
          .removeClass('filled')
          .find('img').attr('src', placeholder);
      }
    });
    var selpack = $('input[name="size-pack"]:checked').attr('value');
    if(selpack == 6 && $('.selected-item-box.filled').length != 6){
        $('.custom-atc-btn-checkout').addClass('disabled');
    }else if(selpack == 12 && $('.selected-item-box.filled').length != 12){
        $('.custom-atc-btn-checkout').addClass('disabled');
    }else if(selpack == 24 && $('.selected-item-box.filled').length != 24){
        $('.custom-atc-btn-checkout').addClass('disabled');
    }else{
         $('.custom-atc-btn-checkout').removeClass('disabled');
    }

    this.updateBundleUi();
  }

  enforceDisable() {}

  queueRepaint() {
    if (this.repaintQueued) return;
    this.repaintQueued = true;
    requestAnimationFrame(() => {
      this.repaintQueued = false;
      this.trimToCapacity();
      this.allocateBoxes();
      this.enforceDisable();
    });
  }

  updateWrapperAndContainer() {
    const size = this.getCapacity();
    this.$selectedWrapperAll.attr('data-wrapper', size);
    this.$selectedContainerAll.attr('data-wrapper-container', size);
    const $boxes = $('.selected-item-box');
    $boxes.removeClass('active').slice(0, size).addClass('active');
    this.queueRepaint();
    this.updatePlusMinusStates();
  }

  onSizePackChange(e) {
    const $radio = $(e.currentTarget);
    this.packSize = $radio.val();
    const varid = $radio.attr('data-variant');
 
    const $wrapper = $('.selling_plan_select_container_product');
    const $sel = $wrapper.is('select') ? $wrapper : $wrapper.find('select');
 
    if (!$sel.data('allOptionsHtml')) {
      $sel.data('allOptionsHtml', $sel.html());
    }
 
    $sel.html($sel.data('allOptionsHtml'));
 
    $sel.find('option').each(function () {
      const $opt = $(this);
      if ($opt.attr('data-varid') !== varid) {
        $opt.remove();
      }
    });
 
    const $visibleOptions = $sel.find('option');

    if ($visibleOptions.length) {
      $sel.val($visibleOptions.first().val()).trigger('change');
    }
    this.setPrices();
    this.updateWrapperAndContainer();
    this.updateBundleUi();
  }

  onPlusMinusClick(e) {
    const $btn  = $(e.currentTarget);
    const $item = $btn.closest('.custom-product-selector-item');
    const $qty  = $item.find('.custom-product-selector-input');
    const was   = parseInt($qty.val(), 10) || 0;
    let val     = was;
    const step  = parseInt($qty.attr('step'), 10) || 1;
    const cap = this.getCapacity();
    let totalOthers = 0;
    $('.custom-product-selector-input').not($qty).each(function () {
      totalOthers += parseInt($(this).val(), 10) || 0;
    });
    if ($btn.hasClass('custom-product-selector-plus')) {
      const maxForThis = Math.max(0, cap - totalOthers);
      val = Math.min(was + step, maxForThis);
    } else {
      val = Math.max(was - step, 0);
    }
    if (val === was) return;
    $qty.val(val);
    if (val > 0 && was === 0) this.setSequenceIfNeeded($item);
    else if (val === 0 && was > 0) this.clearSequence($item);
    this.queueRepaint();
    this.saveSelPack();
    this.syncMinusFromSelpack();
    this.updatePlusMinusStates();
    this.updateBundleUi();
  } 

  onMediaClick(e) {
    $(e.currentTarget)
      .parents('.custom-product-selector-item')
      .find('.popup-description-wrapper-main').show();
    $('html').css('overflow', 'hidden');
  }

  onPopupClose(e) {
    $(e.currentTarget)
      .parents('.custom-product-selector-item')
      .find('.popup-description-wrapper-main').hide();
    $('html').css('overflow', 'auto');
  }


}
customElements.define('custom-bundle-product', CustomBundleProduct);

window.addEventListener("pageshow", function(event) {
  if (event.persisted) {
    window.location.reload();
  }
});